import Vue from 'vue';
import Vuex from 'vuex';
import moduleDeals from './modules/deals';
import moduleFilter from './modules/filter';
import moduleCalculation from './modules/calculation';
import moduleSort from './modules/sort';
import moduleLoading from './modules/loading';
import moduleContent from './modules/content';
import moduleLayout from './modules/layout';
import moduleReactive from './modules/reactive';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    deals: moduleDeals,
    filter: moduleFilter,
    calculation: moduleCalculation,
    sort: moduleSort,
    loading: moduleLoading,
    content: moduleContent,
    layout: moduleLayout,
    reactive: moduleReactive,

  },
  strict: process.env.NODE_ENV !== 'production',
});
